import type { JSX } from 'react';
import { lazy } from 'react';

import { NotFound } from 'common/components/NotFound';
import { Roles } from 'common/constants/roles';
import { Routes } from 'common/constants/routes';

const AclAccessesTab = lazy(() => import('features/aclAccesses/AclAccessesTab').then(m => ({ default: m.AclAccessesTab })));
const AclResourcesTab = lazy(() => import('features/aclResources/AclResourcesTab').then(m => ({ default: m.AclResourcesTab })));
const Acls = lazy(() => import('features/acls/Acls').then(m => ({ default: m.Acls })));
const Admin = lazy(() => import('features/admin/Admin').then(m => ({ default: m.Admin })));
const AccountLinkingDashboard = lazy(() => import('features/admin/subpages/accountLinkingDashboard/AccountLinkingDashboard').then(m => ({ default: m.AccountLinkingDashboard })));
const ApiKeysTab = lazy(() => import('features/apiKeys/ApiKeysTab').then(m => ({ default: m.ApiKeysTab })));
const ApplicationSuiteDetails = lazy(() => import('features/applicationSuiteDetails/ApplicationSuiteDetails').then(m => ({ default: m.ApplicationSuiteDetails })));
const ApplicationSuites = lazy(() => import('features/applicationSuites/ApplicationSuites').then(m => ({ default: m.ApplicationSuites })));
const AuthorizedIssuersTab = lazy(() => import('features/authorizedIssuers/AuthorizedIssuersTab').then(m => ({ default: m.AuthorizedIssuersTab })));
const ClaimDetails = lazy(() => import('features/claimDetails/ClaimDetails').then(m => ({ default: m.ClaimDetails })));
const ClaimRoleMembershipTab = lazy(() => import('features/claimRoleMembership/ClaimRoleMembershipTab').then(m => ({ default: m.ClaimRoleMembershipTab })));
const ClaimsTab = lazy(() => import('features/claims/ClaimsTab').then(m => ({ default: m.ClaimsTab })));
const ClaimUserMembershipTab = lazy(() => import('features/claimUserMembership/ClaimUserMembershipTab').then(m => ({ default: m.ClaimUserMembershipTab })));
const GlobalRoles = lazy(() => import('features/globalRoles').then(m => ({ default: m.GlobalRoles })));
const Help = lazy(() => import('features/Help').then(m => ({ default: m.Help })));
const Imports = lazy(() => import('features/imports/Imports').then(m => ({ default: m.Imports })));
const LicenseAclEntriesTab = lazy(() => import('features/licenseAclEntries/LicenseAclEntriesTab').then(m => ({ default: m.LicenseAclEntriesTab })));
const LicenseDetails = lazy(() => import('features/licenseDetails/LicenseDetails').then(m => ({ default: m.LicenseDetails })));
const LicensesTab = lazy(() => import('features/licenses/LicensesTab').then(m => ({ default: m.LicensesTab })));
const LicenseUserGroupsTab = lazy(() => import('features/licenseUserGroups/LicenseUserGroupsTab').then(m => ({ default: m.LicenseUserGroupsTab })));
const LicenseUsersTab = lazy(() => import('features/licenseUsers/LicenseUsersTab').then(m => ({ default: m.LicenseUsersTab })));
const Monitoring = lazy(() => import('features/monitoring').then(m => ({ default: m.Monitoring })));
const Reports = lazy(() => import('features/reports').then(m => ({ default: m.Reports })));
const AclResourceUserListReport = lazy(() => import('features/reports/components/aclResourceUserListReport/aclResourceUserListReport').then(m => ({ default: m.AclResourceUserListReport })));
const LicenseReport = lazy(() => import('features/reports/components/licenseProofOfDeliveryReport/LicenseReport').then(m => ({ default: m.LicenseReport })));
const UserGroupAclsReport = lazy(() => import('features/reports/components/userGroupAclsReport/userGroupAclsReport').then(m => ({ default: m.UserGroupAclsReport })));
const UserGroupsReport = lazy(() => import('features/reports/components/userGroupsProofOfDeliveryReport/UserGroupsReport').then(m => ({ default: m.UserGroupsReport })));
const UsersWithNewAccessReport = lazy(() => import('features/reports/components/usersWithNewAccessReport/usersWithNewAccessReport').then(m => ({ default: m.UsersWithNewAccessReport })));
const RoleClaimMembershipTab = lazy(() => import('features/roleClaimMembership/RoleClaimMembershipTab').then(m => ({ default: m.RoleClaimMembershipTab })));
const RoleDetails = lazy(() => import('features/roleDetails/RoleDetails').then(m => ({ default: m.RoleDetails })));
const RolesTab = lazy(() => import('features/roles/RolesTab').then(m => ({ default: m.RolesTab })));
const RoleUserGroupTab = lazy(() => import('features/roleUserGroup/RoleUserGroupTab').then(m => ({ default: m.RoleUserGroupTab })));
const RoleUserMembershipTab = lazy(() => import('features/roleUserMembership/RoleUserMembershipTab').then(m => ({ default: m.RoleUserMembershipTab })));
const TenantDetails = lazy(() => import('features/tenantDetails/TenantDetails').then(m => ({ default: m.TenantDetails })));
const TenantsTab = lazy(() => import('features/tenants/TenantsTab').then(m => ({ default: m.TenantsTab })));
const TenantUserMembershipTab = lazy(() => import('features/tenantUserMembership/tenantUserMembershipTab').then(m => ({ default: m.TenantUserMembershipTab })));
const TenantUserMembershipDetails = lazy(() => import('features/tenantUserMembershipDetails/TenantUserMembershipDetails').then(m => ({ default: m.TenantUserMembershipDetails })));
const UserAclEntriesTab = lazy(() => import('features/userAclEntries/UserAclEntriesTab').then(m => ({ default: m.UserAclEntriesTab })));
const UserClaimMembershipTab = lazy(() => import('features/userClaimMembership/UserClaimMembershipTab').then(m => ({ default: m.UserClaimMembershipTab })));
const UserProfileDetails = lazy(() => import('features/userDetails/UserDetails').then(m => ({ default: m.UserProfileDetails })));
const UserGroupAclEntriesTab = lazy(() => import('features/userGroupAclEntries/UserGroupAclEntriesTab').then(m => ({ default: m.UserGroupAclEntriesTab })));
const UserGroupDetails = lazy(() => import('features/userGroupDetails/UserGroupDetails').then(m => ({ default: m.UserGroupDetails })));
const UserGroupRoleMembershipTab = lazy(() => import('features/userGroupRoleMembership/UserGroupRoleMembershipTab').then(m => ({ default: m.UserGroupRoleMembershipTab })));
const UserGroupsUsersTab = lazy(() => import('features/userGroupsUsers/UserGroupsUsersTab').then(m => ({ default: m.UserGroupsUsersTab })));
const UserGroupUserMembershipTab = lazy(() => import('features/userGroupUserMembership/UserGroupUserMembershipTab').then(m => ({ default: m.UserGroupUserMembershipTab })));
const UserRoleMembershipsTab = lazy(() => import('features/userRoleMemberships/UserRoleMembershipsTab').then(m => ({ default: m.UserRoleMembershipsTab })));
const Users = lazy(() => import('features/users/Users').then(m => ({ default: m.Users })));
const UserGroupsTab = lazy(() => import('../../features/userGroups/UserGroupsTab').then(m => ({ default: m.UserGroupsTab })));
const ProductPackagesTab = lazy(() => import('../../features/productPackages/productPackagesTab').then(m => ({ default: m.ProductPackagesTab })));
const ProductPackageDetails = lazy(() => import('features/productPackageDetails/ProductPackageDetails').then(m => ({ default: m.ProductPackageDetails })));
const ProductPackageRalsTab = lazy(() => import('features/productPackageRals/ProductPackageRalsTab').then(m => ({ default: m.ProductPackageRalsTab })));

export type RouteDefinition = {
    path?: string;
    element: JSX.Element;
    roles?: Roles[];
    children?: RouteDefinition[];
};

export const routes: RouteDefinition[] = [
    {
        path: Routes.Tenant,
        element: <TenantDetails />,
        roles: [
            Roles.Admin,
            Roles.AppManager,
            Roles.GlobalRoleManager,
            Roles.MultiTenantRO,
            Roles.UserManager,
        ],
        children: [
            {
                path: Routes.Users,
                element: <TenantUserMembershipTab />
            },
            {
                path: Routes.Licenses,
                element: <LicensesTab />
            },
            {
                path: Routes.UserGroups,
                element: <UserGroupsTab />
            },
            {
                path: Routes.Roles,
                element: <RolesTab />,
                roles: [
                    Roles.Admin,
                    Roles.AppManager,
                    Roles.MultiTenantRO,
                    Roles.UserManager,
                ]
            },
            {
                path: Routes.Claims,
                element: <ClaimsTab />
            },
            {
                path: Routes.Acls,
                element: <Acls />,
                children: [
                    {
                        path: Routes.AclResources,
                        element: <AclResourcesTab />
                    },
                    {
                        path: Routes.AclAccesses,
                        element: <AclAccessesTab />,
                        roles: [
                            Roles.Admin,
                            Roles.AppManager
                        ]
                    }
                ]
            },
            {
                path: Routes.AuthorizedIssuers,
                element: <AuthorizedIssuersTab />
            },
            {
                path: Routes.ProductPackages,
                element: <ProductPackagesTab />
            }
        ]
    },
    {
        path: Routes.ApplicationSuite,
        element: <ApplicationSuiteDetails />,
        roles: [
            Roles.Admin,
            Roles.AppManager,
            Roles.GlobalRoleManager,
            Roles.MultiTenantRO,
            Roles.UserManager,
        ],
        children: [
            {
                path: Routes.Tenants,
                element: <TenantsTab />,
                roles: [
                    Roles.Admin,
                    Roles.AppManager,
                    Roles.MultiTenantRO,
                    Roles.UserManager,
                ],
            },
            {
                path: Routes.ApiKeys,
                element: <ApiKeysTab />,
                roles: [
                    Roles.Admin,
                    Roles.AppManager
                ]
            }
        ]
    },
    {
        path: Routes.Role,
        element: <RoleDetails />,
        roles: [
            Roles.Admin,
            Roles.AppManager,
            Roles.MultiTenantRO,
            Roles.UserManager,
        ],
        children: [
            {
                path: Routes.Users,
                element: <RoleUserMembershipTab />,
                roles: [
                    Roles.Admin,
                    Roles.AppManager,
                    Roles.MultiTenantRO,
                    Roles.UserManager,
                ],
            },
            {
                path: Routes.UserGroups,
                element: <UserGroupRoleMembershipTab />,
                roles: [
                    Roles.Admin,
                    Roles.AppManager,
                    Roles.MultiTenantRO,
                    Roles.UserManager,
                ],
            },
            {
                path: Routes.Claims,
                element: <RoleClaimMembershipTab />,
                roles: [
                    Roles.Admin,
                    Roles.AppManager,
                    Roles.MultiTenantRO,
                    Roles.UserManager,
                ],
            }
        ]
    },
    {
        path: Routes.Claim,
        element: <ClaimDetails />,
        roles: [
            Roles.Admin,
            Roles.AppManager,
            Roles.MultiTenantRO,
            Roles.UserManager,
        ],
        children: [
            {
                path: Routes.Users,
                element: <ClaimUserMembershipTab />,
                roles: [
                    Roles.Admin,
                    Roles.AppManager,
                    Roles.MultiTenantRO,
                    Roles.UserManager,
                ],
            },
            {
                path: Routes.Roles,
                element: <ClaimRoleMembershipTab/>,
                roles: [
                    Roles.Admin,
                    Roles.AppManager,
                    Roles.MultiTenantRO,
                    Roles.UserManager,
                ],
            }
        ]
    },
    {
        path: Routes.UserGroup,
        element: <UserGroupDetails />,
        roles: [
            Roles.Admin,
            Roles.AppManager,
            Roles.MultiTenantRO,
            Roles.UserManager,
        ],
        children: [
            {
                path: Routes.Users,
                element: <UserGroupsUsersTab />,
                roles: [
                    Roles.Admin,
                    Roles.AppManager,
                    Roles.MultiTenantRO,
                    Roles.UserManager,
                ],
            },
            {
                path: Routes.Roles,
                element: <RoleUserGroupTab />,
                roles: [
                    Roles.Admin,
                    Roles.AppManager,
                    Roles.MultiTenantRO,
                    Roles.UserManager,
                ],
            },
            {
                path: Routes.AclEntries,
                element: <UserGroupAclEntriesTab />
            }
        ]
    },
    {
        path: Routes.User,
        element: <TenantUserMembershipDetails />,
        roles: [
            Roles.Admin,
            Roles.AppManager,
            Roles.MultiTenantRO,
            Roles.UserManager,
            Roles.GlobalRoleManager
        ],
        children: [
            {
                path: Routes.Roles,
                element: <UserRoleMembershipsTab />,
                roles: [
                    Roles.Admin,
                    Roles.AppManager,
                    Roles.MultiTenantRO,
                    Roles.UserManager
                ]
            },
            {
                path: Routes.UserGroups,
                element: <UserGroupUserMembershipTab/>,
                roles: [
                    Roles.Admin,
                    Roles.AppManager,
                    Roles.MultiTenantRO,
                    Roles.UserManager,
                ],
            },
            {
                path: Routes.Claims,
                element: <UserClaimMembershipTab/>,
                roles: [
                    Roles.Admin,
                    Roles.AppManager,
                    Roles.MultiTenantRO,
                    Roles.UserManager,
                ],
            },
            {
                path: Routes.AclEntries,
                element: <UserAclEntriesTab />,
                roles: [
                    Roles.Admin,
                    Roles.AppManager,
                    Roles.MultiTenantRO,
                    Roles.UserManager,
                ],
            }
        ]
    },
    {
        path: Routes.License,
        element: <LicenseDetails />,
        roles: [
            Roles.Admin,
            Roles.AppManager,
            Roles.GlobalRoleManager,
            Roles.MultiTenantRO,
            Roles.UserManager,
        ],
        children: [
            {
                path: Routes.Users,
                element: <LicenseUsersTab />
            },
            {
                path: Routes.UserGroups,
                element: <LicenseUserGroupsTab />
            },
            {
                path: Routes.AclEntries,
                element: <LicenseAclEntriesTab />,
                roles: [
                    Roles.Admin,
                    Roles.AppManager,
                    Roles.MultiTenantRO,
                    Roles.UserManager,
                ],
            }
        ]
    },
    {
        path: Routes.ProductPackage,
        element: <ProductPackageDetails />,
        roles: [
            Roles.Admin,
            Roles.AppManager,
            Roles.GlobalRoleManager,
            Roles.MultiTenantRO,
            Roles.UserManager,
        ],
        children: [
            {
                path: Routes.Rals,
                element: <ProductPackageRalsTab />,
                roles: [
                    Roles.Admin,
                    Roles.AppManager,
                    Roles.MultiTenantRO,
                    Roles.UserManager,
                ],
            }
        ]
    },
    {
        path: Routes.UserGroupsReport,
        element: <UserGroupsReport />,
        roles: [
            Roles.Admin,
            Roles.AppManager,
            Roles.MultiTenantRO,
            Roles.UserManager,
        ],
    },
    {
        path: Routes.UserGroupACLsReport,
        element: <UserGroupAclsReport />,
        roles: [
            Roles.Admin,
            Roles.AppManager,
            Roles.MultiTenantRO,
            Roles.UserManager,
        ],
    },
    {
        path: Routes.LicensesReport,
        element: <LicenseReport />,
        roles: [
            Roles.Admin,
            Roles.MultiTenantRO,
            Roles.UserManager,
        ],
    },
    {
        path: Routes.UsersWithNewAccessReport,
        element: <UsersWithNewAccessReport />,
        roles: [
            Roles.Admin,
            Roles.UserManager,
        ],
    },
    {
        path: Routes.AclResourceUserListReport,
        element: <AclResourceUserListReport />,
        roles: [
            Roles.Admin,
            Roles.UserManager,
            Roles.AppManager,
        ],
    },
    {
        path: Routes.ApplicationSuites,
        element: <ApplicationSuites />,
        roles: [
            Roles.Admin,
            Roles.AppManager,
            Roles.MultiTenantRO,
            Roles.UserManager
        ],
    },
    {
        path: Routes.Users,
        element: <Users />,
        roles: [
            Roles.Admin,
            Roles.AppManager,
            Roles.GlobalRoleManager,
            Roles.MultiTenantRO,
            Roles.UserManager,
        ],
    },
    {
        path: Routes.UsersDetails,
        element: <UserProfileDetails />,
        roles: [
            Roles.Admin,
            Roles.AppManager,
            Roles.MultiTenantRO,
            Roles.UserManager,
            Roles.GlobalRoleManager
        ],
    },
    {
        path: Routes.Reports,
        element: <Reports />,
        roles: [
            Roles.Admin,
            Roles.AppManager,
            Roles.MultiTenantRO,
            Roles.UserManager,
        ],
    },
    {
        path: Routes.Monitoring,
        element: <Monitoring />,
        roles: [
            Roles.Admin,
            Roles.AppManager,
            Roles.GlobalRoleManager,
            Roles.MultiTenantRO,
            Roles.UserManager,
        ],
    },
    {
        path: Routes.Admin,
        element: <Admin />,
        roles: [
            Roles.Admin,
            Roles.MultiTenantRO,
            Roles.UserManager
        ],
    },
    {
        path: Routes.AccountLinkingDashboard,
        element: <AccountLinkingDashboard />,
        roles: [
            Roles.Admin,
            Roles.MultiTenantRO,
            Roles.UserManager
        ]
    },
    {
        path: Routes.Imports,
        element: <Imports />,
        roles: [
            Roles.Admin,
            Roles.UserManager
        ]
    },
    {
        path: Routes.GlobalRoles,
        element: <GlobalRoles />,
        roles: [
            Roles.Admin,
            Roles.AppManager,
            Roles.GlobalRoleManager,
            Roles.MultiTenantRO,
            Roles.UserManager,
        ],
    },
    {
        path: Routes.Help,
        element: <Help />,
        roles: [
            Roles.Admin,
            Roles.AppManager,
            Roles.GlobalRoleManager,
            Roles.MultiTenantRO,
            Roles.UserManager,
        ],
    },
    {
        path: Routes.Home,
        element: <></>,
        roles: [
            Roles.Admin,
            Roles.AppManager,
            Roles.GlobalRoleManager,
            Roles.MultiTenantRO,
            Roles.UserManager,
        ],
    },
    {
        path: '*',
        element: <NotFound />,
    }
];
